import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterDist"
    ,pure: false
})
export class FilterDist implements PipeTransform {
    transform(inputValue:any):any {
        if(!inputValue){
            return 0;
        }
        return inputValue * 0.001;
    }
}
